

import { Component, OnInit, Input, EventEmitter, Output, ViewChildren, QueryList, ElementRef} from '@angular/core';
import { AuthService } from 'src/app/services/auth-service/auth.service';
import { Lightbox } from 'ngx-lightbox';
import { DomSanitizer } from '@angular/platform-browser';
import { saveAs} from 'file-saver';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';

@Component({
  selector: 'app-custom-accordion',
  templateUrl: './custom-accordion.component.html',
  styleUrls: ['./custom-accordion.component.scss']
})
export class CustomAccordionComponent implements OnInit {

  openPdf= false;
  selectedPdf = null;
  displayBlock = "none";
  mediaLinks: {[key: string]: string} = {};
  @Input() media: any;
  @Input() position: any;
  @Input() type: any;
  @Input() instanttype: any;
  @Input() isTransfered: any;
  @Output() sendData: EventEmitter<any> = new EventEmitter<any>();
  @ViewChildren('videoPlayer') videoElements: QueryList<ElementRef>;
  public image = ["jpg", "jpeg", "png", "heic"];
  public video = ["video/mp4", "video/webm", "png", "heic"];

  constructor( private authService: AuthService, protected _sanitizer: DomSanitizer, private _lightbox: Lightbox, private httpClient: HttpClient) { }

  ngOnInit() {
    if(this.media.type == "fake" && this.media.extension.startsWith('image')){
      this.getMediaLinkFace2(this.media);
    }
  }

  hidingAndshowing(){
  if (this.displayBlock === "block") {
      this.displayBlock = "none";
      if (this.videoElements) {
        this.videoElements.forEach(videoElement => {
          if (videoElement.nativeElement) {
            videoElement.nativeElement.pause();
          }
        });
      }
    } else {
      this.displayBlock = "block";
    }
  }

  getIcon(extension, extensionfile){
    let filelink = "";
    if(extensionfile){
    if(extensionfile.startsWith('xl') || (extensionfile == 'csv')){
      filelink = "../../assets/icons/excel.png";
    }else if(extensionfile.startsWith('ppt')){
      filelink = "../../assets/icons/ppt.png";
    }else if((extensionfile.startsWith('do') || extensionfile == 'odt')){
      filelink = "../../assets/icons/word.png";
    }else if(extensionfile.includes("zip") || extensionfile.includes("rar")){
      filelink = "../../assets/icons/zip.png";
    }else if(extensionfile.includes("pdf")){
      filelink = "../../assets/icons/pdf.png";
    }else if(extension.includes("image")){
      filelink = "../../assets/icons/image.png";
    }else if(extension.includes("audio")){
      filelink = "../../assets/icons/audio.png";
    }else if(extension.includes("video")){
      filelink = "../../assets/icons/video.png";
    }else if(extensionfile.includes("txt")){
      filelink = "../../assets/icons/txt.png";
    }}

    return filelink ? filelink : false;
  }

  getMediaLinkFace2(media): Promise<string> {
    return new Promise<string>((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (e: any) => {
          const result = e.target.result;
          this.mediaLinks[media.id] = result; // Stockez le résultat dans l'objet
          resolve(result);
        };

        reader.onerror = (error) => {
          reject(error);
        };

        reader.readAsDataURL(media.file);
    });
  }


  getMediaLinkFace(media){
    if(media.type == "fake" && media.file){
      const reader = new FileReader();
      reader.onload = (e: any) => {
        return e.target.result;
      };

      reader.readAsDataURL(media.file);
    }
  }

  getMediaLink(mediaUrl, thumbnailPath=null){
    /*
    if(mediaUrl.type == "fake" && media){
      return mediaUrl.contentUrl;
    }*/
    if(this.instanttype == "yes"|| this.isTransfered =="yes"){
      if(thumbnailPath){
        return this.authService.getMediaDataInstantThumbnail(thumbnailPath);
      } else return this.authService.getMediaDataInstant(mediaUrl);
    } else return this.authService.getMediaData(mediaUrl);
  }
  getPdfLink(mediaUrl){
    if(this.instanttype == "yes" || this.isTransfered =="yes"){
      return this._sanitizer.bypassSecurityTrustResourceUrl(this.authService.getMediaDataInstant(mediaUrl));
    } else return this._sanitizer.bypassSecurityTrustResourceUrl(this.authService.getMediaData(mediaUrl));
    //return this._sanitizer.bypassSecurityTrustResourceUrl(this.authService.getMediaData(mediaUrl));

  }

  downloadImg(img){
    //this.authService.downloadImg(img);
    this.authService.telechargerImage();
  }
  /*
  sendDataToParent(data: any) {
    this.sendData.emit(data);
  }
  */

  afficherFichier(media) {
    const url = this.getMediaLink(media.contentUrl)
    this.httpClient.get(url, { headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + JSON.parse(localStorage.getItem('currentUser'))['token']
    }),responseType: 'blob' }).subscribe(response => {
      const blob = new Blob([response], { type: response.type });
      const url = window.URL.createObjectURL(blob);
      window.open(url);
    });
  }

  telechargerDocument(media) {
    const url = this.getMediaLink(media.contentUrl)
    this.httpClient.get(url, {responseType: 'blob' }).subscribe(response => {
      const blob = new Blob([response], { type: 'application/octet-stream' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = media.originalName; // Remplacez par le nom réel du fichier
      a.click();
      window.URL.revokeObjectURL(url);
    });
  }

  getImage(media: any){
    //this.sendData.emit(media);
   }

  getPdf(media: any){
    //this.sendData.emit(media);
   }
   closeModal(){
    this.selectedPdf=null;
   }

  getMediaThumbail(mediaUrl){
    return this.authService.getMediaThumbail(mediaUrl);
  }

  openWithUrl(url){

    url = this.getMediaLink(url);
    // alert(url)
    const album = {
      src: url
   };
   let albums = [];
   albums.push(album);
   this._lightbox.open(albums, 0);
   setTimeout(() => {
   const lbOuterContainer = document.querySelector('.lb-outerContainer');
    const lbDataContainer = document.querySelector('.lb-dataContainer');
   
    if (lbOuterContainer && lbDataContainer) {
      lbOuterContainer.parentNode.insertBefore(lbDataContainer, lbOuterContainer);
    }
  }, 100);

   setTimeout(() => {
    document.querySelector( 'img.lb-image' ).removeAttribute("hidden");
    if(document.querySelector( '.lb-loader' )) document.querySelector( '.lb-loader' ).setAttribute("hidden", "true");
    if(document.querySelector( '.lb-nav' )) document.querySelector( '.lb-nav' ).setAttribute("hidden", "true");
   }, 1500);

  }

  openWithData(file){

    const reader = new FileReader();
    reader.onload = (e: any) => {
       const album = {
          src: e.target.result
       };
       let albums = [];
       albums.push(album);
       this._lightbox.open(albums, 0);

       setTimeout(() => {
        document.querySelector( 'img.lb-image' ).removeAttribute("hidden");
        if(document.querySelector( '.lb-loader' )) document.querySelector( '.lb-loader' ).setAttribute("hidden", "true");
        if(document.querySelector( '.lb-nav' )) document.querySelector( '.lb-nav' ).setAttribute("hidden", "true");
       }, 1500);

    };
    reader.readAsDataURL(file);

  }


  createFileUrl(url, source){
    source.href = URL.createObjectURL(this.getMediaLink(url));
  }


}
